import type { Dict } from './en';

/** Uzbek (Latin). */
const uz: Dict = {
  languageName: "O'zbekcha",

  nav: {
    products: 'Mahsulotlar',
    team: 'Jamoa',
    about: 'Biz haqimizda',
    contact: "Bog'lanish",
  },

  hero: {
    eyebrow: 'Vaqtly Holding',
    headlinePre: 'Har kuni ishlatiladigan ',
    headlineAccent: 'mahsulotlar',
    headlinePost: ' quramiz.',
    body:
      "Vaqtly — O'zbekistonda raqamli mahsulotlar quruvchi holding. Hozirda ikkita startapimiz " +
      'ishlab turibdi.',
    ctaPrimary: 'Mahsulotlarimiz',
    ctaSecondary: "Bog'lanish",
  },

  products: {
    eyebrow: 'Mahsulotlar',
    heading: 'Vaqtly startaplari',
    visit: "Saytga o'tish",
    status: {
      live: 'Ishlamoqda',
      beta: 'Beta',
      soon: 'Tez orada',
    },
  },

  team: {
    eyebrow: 'Jamoa',
    heading: 'Mahsulotlar ortidagi odamlar',
    body: "Har bir mahsulotning o'z kichik jamoasi bor va uni boshidan oxirigacha o'zi olib boradi.",
    founders: 'Kompaniya asoschilari',
  },

  roles: {
    founder: 'Asoschi',
    cofounder: 'Hammuassis',
    founderCeo: 'Asoschi va bosh direktor',
    ceo: 'Bosh direktor',
    cto: 'Texnik direktor',
    engineer: 'Dasturchi',
    designer: 'Dizayner',
    product: 'Mahsulot menejeri',
    marketing: 'Marketing',
    content: 'Kontent',
    operations: 'Operatsiyalar',
  },

  principles: {
    eyebrow: 'Biz haqimizda',
    heading: 'Qanday ishlaymiz',
    items: [
      {
        title: 'Har kuni ochiladigan mahsulot',
        body: 'Bir marta ishlatiladigan emas, odatga aylanadigan mahsulotlar quramiz.',
      },
      {
        title: 'Mahalliy kontekst',
        body: "Mahsulotlarimiz O'zbekistondagi real ehtiyojdan kelib chiqadi va o'zbek tilida gapiradi.",
      },
      {
        title: 'Kichik jamoa, tez yetkazish',
        body: "Uzoq rejalar emas — ishlaydigan versiyani tezroq chiqarib, foydalanuvchidan o'rganamiz.",
      },
    ],
  },

  contact: {
    heading: 'Hamkorlik yoki savol bormi?',
    body: "Jamoamizga to'g'ridan-to'g'ri yozing — har bir xatni o'qiymiz.",
  },

  footer: {
    tagline: 'Vaqtly Holding — raqamli mahsulotlar quruvchi kompaniya.',
    products: 'Mahsulotlar',
    contact: 'Aloqa',
    about: 'Biz haqimizda',
    rights: 'Barcha huquqlar himoyalangan.',
  },

  product: {
    'russian-gg': {
      tagline: '90 kunda rus tilida gapiring.',
      description:
        "Ovozli mashqqa asoslangan til platformasi. Har kuni 15–20 daqiqa — haqiqiy ish va " +
        "kundalik vaziyatlarda, o'zbek tilidagi qo'llab-quvvatlash bilan.",
    },
    sevil: {
      tagline: "Cho'ntagingizdagi AI stilist.",
      description:
        "Sun'iy intellektga asoslangan shaxsiy stilist. Uslub bo'yicha maslahatni o'zbek " +
        'tilida, telefoningiz orqali beradi.',
    },
  },
};

export default uz;
